import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { authService } from '../services/authService';
import './AdminLogin.css';

const ResetPassword: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [token, setToken] = useState('');

  useEffect(() => {
    const tokenParam = searchParams.get('token');
    if (!tokenParam) {
      setError('Token inválido. Por favor solicita un nuevo enlace de restablecimiento.');
    } else {
      setToken(tokenParam);
    }
  }, [searchParams]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (newPassword !== confirmPassword) {
      setError('Las contraseñas no coinciden');
      return;
    }

    if (newPassword.length < 8) {
      setError('La contraseña debe tener al menos 8 caracteres');
      return;
    }

    setLoading(true);

    try {
      const result = await authService.resetPassword(token, newPassword, confirmPassword);

      if (result.success) {
        setSuccess(true);
        setTimeout(() => {
          navigate('/admin/login');
        }, 3000);
      } else {
        setError(result.message);
      }
    } catch (err: any) {
      setError(err.message || 'Error al restablecer contraseña');
    } finally {
      setLoading(false);
    }
  };

  if (!token && !error) {
    return (
      <div className="admin-login-container">
        <div className="login-box">
          <div className="login-header">
            <h1>Cargando...</h1>
          </div>
        </div>
      </div>
    );
  }

  if (success) {
    return (
      <div className="admin-login-container">
        <div className="login-box">
          <div className="login-header">
            <h1>✅ Contraseña Restablecida</h1>
          </div>
          <div className="success-message">
            <p>Tu contraseña ha sido restablecida exitosamente.</p>
            <p>Redirigiendo al login...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-login-container">
      <div className="login-box">
        <div className="login-header">
          <h1>🔑 Restablecer Contraseña</h1>
          <p>Ingresa tu nueva contraseña</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          {error && (
            <div className="error-message">
              ⚠️ {error}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="newPassword">Nueva Contraseña</label>
            <input
              type="password"
              id="newPassword"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              placeholder="Mínimo 8 caracteres"
              disabled={loading || !token}
              autoFocus
            />
            <small style={{ color: '#718096', fontSize: '12px' }}>
              Debe tener al menos 8 caracteres, una mayúscula, una minúscula, un número y un carácter especial
            </small>
          </div>

          <div className="form-group">
            <label htmlFor="confirmPassword">Confirmar Contraseña</label>
            <input
              type="password"
              id="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              placeholder="Repite la contraseña"
              disabled={loading || !token}
            />
          </div>

          <button
            type="submit"
            className="btn-login"
            disabled={loading || !token}
          >
            {loading ? 'Restableciendo...' : 'Restablecer Contraseña'}
          </button>

          <button
            type="button"
            className="btn-forgot-password"
            onClick={() => navigate('/admin/login')}
            disabled={loading}
          >
            ← Volver al login
          </button>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
